const supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
export default function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}